import { Template } from "../../../../../../core/template/index";
import ReceiveQuantityModal from "../../../modals/receive_quantity/index";
import { FortumApp } from "../../../../../fortumApp";
import { ScannedItemView } from "../../../scan_packages/scanned_item";


export class ReceiveItemView extends ScannedItemView {

    app: FortumApp;
    template = Template.lazy('/app/views/package_tracking/receive/partials/receive_item/index.html');

    isReceived: boolean;
    itemDescription: HTMLElement;
    itemNumber: HTMLElement;
    quantityWrapper: HTMLElement;
    selectionWrapper: HTMLElement;
    quantity: HTMLElement;
    totalQuantity: HTMLElement;

    isSelected: Boolean = true;

    public updateItemData(data)
    {
        if (!data.totalQuantity) {
            data.totalQuantity = data.quantity;
        }
        this.isReceived = data.received_quantity ? true: false;
        this.element.classList.add('success');
        this.element.classList.remove('loading');
        this.quantityWrapper.classList.remove('hidden');
        if (!this.isReceived) {
            this.selectionWrapper.classList.remove ('hidden');
        }

        this.quantity.textContent = String(data.received_quantity || data.quantity);
        this.totalQuantity.textContent = `${data.totalQuantity} ${data.quantity_unit}`;
        this.itemDescription.textContent = data.item_description;
        this.itemNumber.textContent = data.item;
        this.item = Object.assign({}, data);
        this.item.isSelected = true;
    }

    protected onDataLoadedSuccessfully(data: any) {
        this.updateItemData(data);
        if (!this.isReceived) {
            this.element.addEventListener('click', event => {
                if ((<HTMLInputElement>event.target).type != 'checkbox') {
                    event.preventDefault();
                    new ReceiveQuantityModal(this).showIn(this.app);
                }
            });
        }
    }

    public onCheckboxChanged() {
        this.item.isSelected = (<HTMLInputElement>event.target).checked;
    }

    protected onDataLoadError(error: any) {
        this.element.classList.remove('loading');
        this.element.classList.add('error');
        this.itemNumber.textContent = error.message || this.app.pgettext('Error', 'Unable to resolve package information');
    }

}